import { PAYMENT_MODULE } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import { useAPIUtils } from "../../useAPIUtils";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import { setDebitNoteList } from "@/app_redux/reducers/slices/auth/cart_slice";

AxiosCurlirize(axios, () => {});
type ICartAPIResponse = { status: boolean; message: string };

export const usePaymentFinanceDebitNoteListAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  // isCustomerWalletTableInProgress
  const execute = useCallback(
    async (from_date: string, to_date: string, search_keyword: string, status: string) => {
      try {
        dispatch(
          setLoading({
            key: "isCustomerDebitNoteTableInProgress",
            status: true,
          }),
        );
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: ICartAPIResponse = await axios
          .get(
            `${PAYMENT_MODULE?.DEBIT_NOTE_LIST_FINANCE?.baseURL}?from_date=${from_date}&to_date=${to_date}&search_keyword=${search_keyword}&status=${status}`,
            {
              headers: {
                Authorization: `${accessToken}`,
                "Content-Type": "application/json",
              },
            },
          )
          .then((res: AxiosResponse<any>) => {
            if (res.data.status === true) {
              dispatch(setDebitNoteList(res.data.data?.debit_notes_data));
              dispatch(
                setLoading({
                  key: "isCustomerDebitNoteTableInProgress",
                  status: false,
                }),
              );
              return { status: true, message: "Cart Level Coupons Fetched" };
            } else {
              dispatch(setDebitNoteList([]));
              dispatch(
                setLoading({
                  key: "isCustomerDebitNoteTableInProgress",
                  status: false,
                }),
              );

              return { status: false, message: "No Cart Level Coupons" };
            }
          })
          .catch((e: AxiosError) => {
            dispatch(setDebitNoteList([]));

            sendCurl(e.config["curlCommand"]);
            captureError(e);
            dispatch(
              setLoading({
                key: "isCustomerDebitNoteTableInProgress",
                status: false,
              }),
            );
            return { status: false, message: "cart_not_filtered" };
          });
        return response;
      } catch (e: any) {
        dispatch(setDebitNoteList([]));
        dispatch(
          setLoading({
            key: "isCustomerDebitNoteTableInProgress",
            status: false,
          }),
        );
        setDebitNoteList([]);
        captureError(e);
      }
    },
    [dispatch],
  );
  return { execute };
};
